import React from "react";
import styles from './FJStockBox.module.less'

function FJStockBox(props) {
  const {render} = props;
  return (
    <div className={styles.box}>
      {render()}
    </div>
  );
}

export default FJStockBox;